"use client";

import type { UserRoles } from "@vellum/vellum-api";

import { describeVisibility, VISIBILITY_ROLES } from "../lib/roleVisibility";
import { Select } from "./Select";

interface RoleOption {
  value: UserRoles;
  label: UserRoles;
}

const ROLE_OPTIONS: RoleOption[] = VISIBILITY_ROLES.map((role) => ({
  value: role,
  label: role,
}));

interface RoleVisibilitySelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  /** Noun used in the helper text, e.g. "link", "report", "flag". */
  itemLabel?: string;
}

/**
 * Multi-select of roles, matching the status/facility/region filter pattern.
 * Selecting none is a real state, not an unfinished one — it means the item
 * is visible to everyone, so we say so.
 */
export function RoleVisibilitySelect({
  value,
  onChange,
  itemLabel = "item",
}: RoleVisibilitySelectProps) {
  return (
    <div>
      <Select
        name="visible_to_roles"
        label="Role visibility"
        isMulti
        isClearable
        options={ROLE_OPTIONS}
        value={ROLE_OPTIONS.filter((option) => value.includes(option.value))}
        onChange={(selected: RoleOption[] | null) =>
          onChange((selected ?? []).map((option) => option.value))
        }
        placeholder="Select roles..."
      />
      <p className="mt-1.5 text-xs text-gray-500">
        Visible to:{" "}
        <span className="font-semibold">{describeVisibility(value)}</span>
        {value.length === 0
          ? ` — select roles to restrict this ${itemLabel}.`
          : null}
      </p>
    </div>
  );
}
